import React, { useState } from 'react'

import { CheckButton } from './CheckButton/CheckButton'
import { TaskEditor } from './TaskEditor/TaskEditor'

import { Task } from 'data/categories'

type PropsType = {
  task: Task
  setScrollTop: (scroll: number) => void
}

export const EditorForm = ({ task, setScrollTop }: PropsType) => {
  const [codeLines, setCodeLines] = useState<string[]>([])

  return (
    <>
      <TaskEditor task={task} setScrollTop={setScrollTop} setCodeLines={setCodeLines} />
      <CheckButton task={task} codeLines={codeLines} />
    </>
  )
}
